import PasswordField from 'Components/PasswordField';
import ResendConfirmation from 'Components/ResendConfirmation';
import { GoogleLogin } from '@react-oauth/google';
import useShowMsg from 'hooks/useShowMsg';
import React from 'react';
import { useForm, Controller } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { apiGoogleLoginRequest } from 'Redux/actions/login';

import { FormErrorText } from '../../Components/CommonStyles';
import AuthLayout from '../../Layouts/AuthLayout';
import { TextLink } from './styles';

const LoginPage = ({ auth, onSubmit, confirmationError }) => {
  const {
    control,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();
  const { showMsg } = useShowMsg(auth);

  const dispatch = useDispatch();
  const errorCode = auth.error?.code;

  return (
    <AuthLayout
      title="Login"
      description="Welcome back! Please enter your details."
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="mb-3">
          <label htmlFor="email" className="form-label">
            Email
          </label>
          <Controller
            name="email"
            control={control}
            defaultValue=""
            rules={{
              required: 'This field is required.',
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                message: 'Enter a valid e-mail address',
              },
            }}
            render={({ field }) => (
              <input
                {...field}
                type="email"
                className="form-control"
                id="email"
                placeholder="Enter your email"
              />
            )}
          />
          {errors.email && (
            <FormErrorText className="form-text">
              {errors.email.message}
            </FormErrorText>
          )}
        </div>
        <div className="mb-3">
          <label htmlFor="password" className="form-label">
            Password
          </label>
          <Controller
            name="password"
            control={control}
            defaultValue=""
            rules={{
              required: 'This field is required.',
            }}
            render={({ field }) => (
              // <input
              //   {...field}
              //   type="password"
              //   className="form-control"
              //   id="password"
              // />
              <PasswordField {...field} />
            )}
          />

          {errors.password && (
            <FormErrorText className="form-text">
              {errors.password.message}
            </FormErrorText>
          )}
        </div>
        <div className="mb-3 d-flex justify-content-end">
          <TextLink to="/forget-password">Forgot Password</TextLink>
        </div>
        <div className="d-grid gap-2">
          <button
            disabled={auth.isLoading}
            type="submit"
            className="btn btn-primary"
          >
            Sign in
          </button>
        </div>

        {/* <p className="form-text text-center mt-4">
          Don’t have an account? <TextLink to="/signup">Sign up</TextLink>
        </p>

        {auth.error !== null ? (
          <div className="mt-3">
            <div className="alert text-center alert-danger" role="alert">
              {auth.error.message}
            </div>
          </div>
        ) : (
          <></>
        )} */}
      </form>
      <div className="d-flex justify-content-center mt-3">
        <GoogleLogin
          onSuccess={({ credential }) =>
            dispatch(apiGoogleLoginRequest(credential))
          }
          onError={() => toast.error('Google sign-in failed. Please try again.')}
          text="signin_with"
          width="320"
        />
      </div>
      <p className="form-text text-center mt-4">
        Don’t have an account? <TextLink to="/signup">Sign up</TextLink>
      </p>

      {/* Expired confirmation link, and an unverified account on login: same
          component, and both need the address typed in the form above. */}
      {confirmationError?.code === 'token_expired' && (
        <ResendConfirmation
          email={watch('email')}
          message="This link has expired. Enter your email above and resend it."
        />
      )}

      {confirmationError && confirmationError.code !== 'token_expired' && (
        <div className="alert alert-warning text-center mt-3" role="alert">
          {confirmationError.detail}
        </div>
      )}

      {errorCode === 'verify_email_first' && (
        <ResendConfirmation
          email={auth.error.email || watch('email')}
          message={auth.error.detail}
        />
      )}

      {/* Google-only account: no "set a password" link here — that lives behind auth. */}
      {errorCode === 'use_google_signin' && (
        <div className="alert alert-warning text-center mt-3" role="alert">
          {auth.error.detail}
        </div>
      )}

      {errorCode === 'account_disabled' && (
        <div className="alert alert-danger text-center mt-3" role="alert">
          {auth.error.detail}
        </div>
      )}

      {auth.error && !errorCode && showMsg ? (
        <div className="mt-3">
          <div className="alert text-center alert-danger" role="alert">
            {auth.error.detail}
          </div>
        </div>
      ) : (
        <></>
      )}
    </AuthLayout>
  );
};

export default LoginPage;
